import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { notificationContainer } from 'utils/notificationContainer';
import {
	getEmailsListRequest,
	getEmailsListSuccess,
	getEmailsListFailure,
	getEmailsTypesRequest,
	getEmailsTypesSuccess,
	getEmailsTypesFailure,
} from './reducer';
import {
	TEmailsListRequest,
	TEmailsListResponsePayload,
	TEmailsTypesResponsePayload,
} from './types';

function* getEmailsListRequestWorker({ payload }: PayloadAction<TEmailsListRequest>) {
	try {
		const response: TEmailsListResponsePayload = yield call(
			api.emails.getEmailsList,
			payload,
		);
		yield put(getEmailsListSuccess(response));
	} catch (error) {
		yield put(getEmailsListFailure());
		notificationContainer(error instanceof Error ? error.message : 'Failed to load emails list', 'error');
	}
}

function* getEmailsTypesRequestWorker() {
	try {
		const response: TEmailsTypesResponsePayload = yield call(api.emails.getEmailsTypes);
		yield put(getEmailsTypesSuccess(response));
	} catch (error) {
		yield put(getEmailsTypesFailure());
		notificationContainer(error instanceof Error ? error.message : 'Failed to load email types', 'error');
	}
}

export function* emailsSaga() {
	yield takeEvery(getEmailsListRequest.type, getEmailsListRequestWorker);
	yield takeEvery(getEmailsTypesRequest.type, getEmailsTypesRequestWorker);
}
